<!-- Botón flotante -->
<button pButton type="button" icon="pi pi-plus-circle" class="p-button-rounded p-button-lg p-button-primary shadow-lg"
    (click)="abrirDialogo()">
</button>

<!-- Dialogo de formulario -->
<p-dialog [(visible)]="showDialog" modal [header]="header" [style]="{ width: '80%' }">
    <form [formGroup]="formulario" (ngSubmit)="agregarNuevo()">
        <div class="grid grid-cols-1 gap-x-6 gap-y-4 w-full">
            @for (campo of campos; track campo) {
                <div class="flex flex-col gap-1">
                    <label class="mb-1 font-medium text-sm">
                        {{ campo.label }}
                        @if (campo.requerido) {
                        <span>*</span>
                        }
                    </label>

                    @if (campo.tipo === 'input') {
                    <input pInputText [formControlName]="campo.formControlName" placeholder="Ingrese..." />
                    }

                    @if (campo.tipo === 'select') {
                    <p-select [showClear]="true" [options]="obtenerOpciones(campo.formControlName)"
                        [formControlName]="campo.formControlName" placeholder="Seleccione..." [appendTo]="'body'"
                        filter />
                    }

                    @if (campo.tipo === 'multiselect') {
                    <p-multiSelect [options]="obtenerOpciones(campo.formControlName)"
                        [formControlName]="campo.formControlName" display="chip" [appendTo]="'body'" filter />
                    }

                    @if (campo.tipo === 'datepicker') {
                    <p-datepicker [formControlName]="campo.formControlName" placeholder="Seleccione una fecha"
                        dateFormat="dd/mm/yy" [showIcon]="true" [iconDisplay]="'input'" [appendTo]="'body'"
                        [style]="{ width: '100%' }" />
                    }

                    @if (campo.tipo === 'textarea') {
                    <textarea pInputTextarea [formControlName]="campo.formControlName" rows="3"
                        placeholder="Ingrese..."></textarea>
                    }

                    @if (campo.tipo === 'file') {
                    <p-fileUpload mode="basic" name="file" chooseLabel="Adjuntar archivo" chooseIcon="pi pi-upload"
                        [auto]="false" [customUpload]="true" [formControlName]="campo.formControlName"
                        class="flex-shrink-0" (change)="onFileChange($event, campo.formControlName)" />
                    }

                    @if (campo.tipo === 'listbox') {
                    <p-listbox [options]="campo.options" [multiple]="true" [checkbox]="true"
                        formControlName="{{campo.formControlName}}">
                    </p-listbox>
                    }

                    @if (campo.tipo === 'autocomplete') {
                    <p-autocomplete [formControlName]="campo.formControlName"
                        [suggestions]="campo.suggestions ? campo.suggestions() : []"
                        (completeMethod)="campo.completeMethod && campo.completeMethod($event)"
                        [optionLabel]="campo.optionLabel || 'label'" placeholder="Escriba para buscar..."
                        appendTo="self" style="width: 100% !important;"
                        [emptyMessage]="getTranslation('emptyMessage')" />
                    }

                    <!-- Mensaje de error -->
                    <app-input-error [control]="formulario.get(campo.formControlName)"></app-input-error>
                </div>
            }
        </div>

        <!-- Botones -->
        <div class="flex justify-end gap-2 mt-6">
            <button pButton type="button" label="Cancelar" class="p-button-secondary"
                (click)="cerrarDialogo()"></button>
            <button pButton type="submit" label="Guardar" class="p-button-primary"
                [disabled]="formulario.invalid"></button>
        </div>
    </form>
</p-dialog>